import { createContext } from 'react';
import AuthContextType from '@domain/auth/types/auth.context.type';

const AuthContext = createContext({} as AuthContextType);

export default AuthContext;
